// src/components/public/PasswordInput.js
import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

/** Password box with a show / hide button. Takes the usual input props. */
export default function PasswordInput({ className = "", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="auth-password">
      <input {...props} className={`auth-input ${className}`} type={show ? "text" : "password"} />
      <button type="button" className="auth-eye" aria-label={show ? "Hide password" : "Show password"} onClick={() => setShow((s) => !s)} disabled={props.disabled}>
        {show ? <FiEyeOff /> : <FiEye />}
      </button>
    </div>
  );
}
